import React, { Component } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Checkup from "../components/checkup"
import AiLogosMarquee from "../components/AiLogosMarquee"
import checkModal from "../assets/img/check-modal.png"
import social from "../assets/img/yapay-zeka-danismanligi-banner.webp"
import balance from "../assets/img/generative-ai/one.webp"
import achievement from "../assets/img/generative-ai/two.webp"
import videoSearch from "../assets/img/generative-ai/three.webp"
import cv from "../assets/img/generative-ai/four.webp"
import maleMan from "../assets/img/generative-ai/five.webp"
import business from "../assets/img/generative-ai/six.webp"
import seven from "../assets/img/generative-ai/seven.webp"
import eight from "../assets/img/generative-ai/eight.webp"
import yapayAudits from "../assets/img/yapay-audits.webp"
import veri1 from "../assets/img/generative-ai/veri1.webp"
import veri2 from "../assets/img/generative-ai/veri2.webp"
import veri3 from "../assets/img/generative-ai/veri3.webp"

class AiConsulting extends Component {
  constructor(props) {
    super(props)
    this.state = {
      display: false,
      value: "",
    }
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(e) {
    e.preventDefault()
    this.setState({ value: e.target.value })
  }

  showModal() {
    this.setState({ display: !this.state.display })
    document.querySelector(".check-modal").classList.add("active-modal")
  }

  closeModal() {
    this.setState({ display: !this.state.display })
    document.querySelector(".check-modal").classList.remove("active-modal")
  }

  handleSubmit(e) {
    e.preventDefault()
    const title = document.title.split("|", 1).toString()
    const response = fetch("https://forms.flatart.com.tr/index.php?r=app%2Ff&id=7", {
      method: "POST",
      body: JSON.stringify({
        text_327649: title,
        text_204202: document.querySelector("#site").value,
        text_775908: document.querySelector("#name").value,
        text_532192: document.querySelector("#email").value,
      }),
      headers: { "Content-type": "application/json; charset=UTF-8" },
    })
    response.then(res => {
      if (res.status === 200) {
        document.querySelector(".status").innerHTML = "Your message has been sent successfully."
      } else {
        document.querySelector(".status").innerHTML = "An error occurred."
      }
    })
  }

  render() {
    return (
      <Layout>
        <SEO
          title="AI Consulting | Generative AI Solutions | Flatart"
          description="Transform your business with AI-powered solutions. Chatbots, content generation, and automation. Get customized Generative AI consulting from Flatart."
        />

        {/* HERO */}
        <div className="seo-service container">
          <div className="seo-service__head custom">
            <div className="col-md-6">
              <h1>AI Consulting</h1>
              <span className="red-head">AI STUDIO</span>
              <p>Transform your business processes with AI-powered generative solutions.</p>
              <div className="ai-input-wrap">
                <input
                  type="text"
                  className="pink-input"
                  placeholder="Enter your e-mail address"
                  value={this.state.value}
                  onChange={this.handleChange}
                />
                <button className="red-button" onClick={() => this.showModal()}>
                  Get your special offer
                </button>
              </div>
            </div>
            <div className="col-md-6 seo-top-right">
              <img alt="AI Consulting" src={social} />
            </div>
            <div className="check-modal">
              <span onClick={() => this.closeModal()}>X</span>
              <h2 className="form-head">Fill the form</h2>
              <p className="form-desc">Enter your information in the fields to get information, and we will get back to you as soon as possible.</p>
              <div className="check-modal_container">
                <form onSubmit={e => this.handleSubmit(e)}>
                  <input type="text" name="text_204202" id="site" required placeholder="Enter your website." />
                  <input type="text" id="name" required name="text_775908" placeholder="Enter your name" />
                  <input type="email" id="email" required name="text_532192" value={this.state.value} onChange={this.handleChange} autoFocus={true} placeholder="Enter your email" />
                  <button>SEND</button>
                  <div className="status"></div>
                </form>
                <img alt="" src={checkModal} />
              </div>
            </div>
          </div>
        </div>

        {/* AI LOGOS MARQUEE */}
        <div className="seo-service gads container yapay">
          <AiLogosMarquee />

          <div className="row labh2">
            <div className="ai-ort yapay">
              <h2 className="h2-ai-h2">What is Generative AI?</h2>
              <p className="flatlab-p now">
                Generative AI refers to artificial intelligence technologies that produce new content, visuals, text, audio, or business solutions from data. In the business world, this technology is used across many areas — from customer service to content production, from automation to data analytics processes. As Flatart AI Studio, we develop custom generative AI solutions for your business and make your workflows more efficient.
              </p>
            </div>
          </div>
        </div>

        {/* BENEFITS — AUDIT STYLE */}
        <div className="seo-services container">
          <div className="seo-services_content" id="seo-audits">
            <div className="col-md-4 seoajansi">
              <img alt="AI Consulting Benefits" className="seoaudits" src={yapayAudits} loading="lazy" />
              <h2 style={{ fontWeight: 500, fontSize: 26 }}>Benefits of AI<br />Consulting</h2>
              <p>Transform your business processes with AI-powered generative solutions.</p>
            </div>
            <div className="col-md-8 content-list">
              <div className="col-md-6 audits-info">
                <h3 style={{ fontWeight: 500 }}>Process Automation</h3>
                <p>Delegate repetitive tasks to AI and let your team focus on innovation. Smart process designs make your operations faster, error-free, and sustainable.</p>
              </div>
              <div className="col-md-6 audits-info">
                <h3 style={{ fontWeight: 500 }}>Smarter Decision Making</h3>
                <p>Your data becomes more than just numbers — it turns into your strategic advantage. AI-driven analytics make your decision-making faster and more accurate.</p>
              </div>
              <div className="col-md-6 audits-info">
                <h3 style={{ fontWeight: 500 }}>Resource & Budget Efficiency</h3>
                <p>AI investments reduce your costs in the long run. Automation and optimization in processes provide significant savings in both human resources and budget.</p>
              </div>
              <div className="col-md-6 audits-info">
                <h3 style={{ fontWeight: 500 }}>Strategic Guidance & Expertise</h3>
                <p>Our experienced consulting team ensures you use the right technology in the right place. We minimize risks and maximize success rates with project-specific guidance.</p>
              </div>
              <div className="col-md-6 audits-info">
                <h3 style={{ fontWeight: 500 }}>Scalable Future</h3>
                <p>Projects starting with a small pilot evolve into a growing digital ecosystem. Your AI infrastructure adapts easily to changing needs, carrying you into the future.</p>
              </div>
            </div>
          </div>
        </div>

        {/* SERVICE CIRCLES */}
        <div className="seo-process py60 container">
          <h2>What Services Can I Get with AI Consulting?</h2>
          <div className="circles">
            <div className="circle yapay">
              <h3 className="yapay">Data Analysis &amp;<br />Strategy</h3>
              <p className="yapay">Designing AI scenarios tailored to your company's specific needs.</p>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width="8.51" height="13.5" viewBox="0 0 8.51 13.5">
              <path d="M90.411,5.97,84.761.329a1.088,1.088,0,0,0-1.56,0l-.659.65a1.061,1.061,0,0,0-.321.78,1.109,1.109,0,0,0,.321.789l4.211,4.2-4.211,4.211a1.061,1.061,0,0,0-.321.78,1.109,1.109,0,0,0,.321.789l.659.65a1.109,1.109,0,0,0,1.56,0l5.65-5.641a1.109,1.109,0,0,0,.321-.789A1.061,1.061,0,0,0,90.411,5.97Z" transform="translate(-82.222 0)" fill="#ea4f6a" />
            </svg>
            <div className="circle yapay">
              <h3 className="yapay">Chatbot &amp;<br />Automation</h3>
              <p className="yapay">Implementation of generative chatbot solutions for intelligent customer experiences.</p>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width="8.51" height="13.5" viewBox="0 0 8.51 13.5">
              <path d="M90.411,5.97,84.761.329a1.088,1.088,0,0,0-1.56,0l-.659.65a1.061,1.061,0,0,0-.321.78,1.109,1.109,0,0,0,.321.789l4.211,4.2-4.211,4.211a1.061,1.061,0,0,0-.321.78,1.109,1.109,0,0,0,.321.789l.659.65a1.109,1.109,0,0,0,1.56,0l5.65-5.641a1.109,1.109,0,0,0,.321-.789A1.061,1.061,0,0,0,90.411,5.97Z" transform="translate(-82.222 0)" fill="#ea4f6a" />
            </svg>
            <div className="circle yapay">
              <h3 className="yapay">Content<br />Generation</h3>
              <p className="yapay">Automated content creation for blogs, social media, product descriptions and more.</p>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width="8.51" height="13.5" viewBox="0 0 8.51 13.5">
              <path d="M90.411,5.97,84.761.329a1.088,1.088,0,0,0-1.56,0l-.659.65a1.061,1.061,0,0,0-.321.78,1.109,1.109,0,0,0,.321.789l4.211,4.2-4.211,4.211a1.061,1.061,0,0,0-.321.78,1.109,1.109,0,0,0,.321.789l.659.65a1.109,1.109,0,0,0,1.56,0l5.65-5.641a1.109,1.109,0,0,0,.321-.789A1.061,1.061,0,0,0,90.411,5.97Z" transform="translate(-82.222 0)" fill="#ea4f6a" />
            </svg>
            <div className="circle yapay">
              <h3 className="yapay">AI<br />Integrations</h3>
              <p className="yapay">WhatsApp Marketing, popup builder, QR solutions, and custom API integrations.</p>
            </div>
          </div>
        </div>

        {/* INDUSTRY GRID */}
        <div className="container manage-google s">
          <h2>Industry-Specific Generative AI Solutions</h2>
          <div>
            <div className="col-md-6 manage-google_item s">
              <img alt="E-Commerce" src={balance} />
              <div>
                <h3 style={{ fontWeight: 500 }}>E-Commerce</h3>
                <p>Order and inventory management becomes significantly easier.</p>
              </div>
            </div>
            <div className="col-md-6 manage-google_item s">
              <img alt="Healthcare" src={achievement} />
              <div>
                <h3 style={{ fontWeight: 500 }}>Healthcare</h3>
                <p>Patient communication and report summarization is automated.</p>
              </div>
            </div>
            <div className="col-md-6 manage-google_item s">
              <img alt="Finance" src={videoSearch} />
              <div>
                <h3 style={{ fontWeight: 500 }}>Finance</h3>
                <p>Customer service accelerates and transactions become secure.</p>
              </div>
            </div>
            <div className="col-md-6 manage-google_item s">
              <img alt="Education" src={cv} />
              <div>
                <h3 style={{ fontWeight: 500 }}>Education</h3>
                <p>Virtual assistants support personalized learning journeys.</p>
              </div>
            </div>
            <div className="col-md-6 manage-google_item s">
              <img alt="Tourism & Hospitality" src={maleMan} />
              <div>
                <h3 style={{ fontWeight: 500 }}>Tourism &amp; Hospitality</h3>
                <p>Reservation processes speed up and guest experience is enriched with real-time data.</p>
              </div>
            </div>
            <div className="col-md-6 manage-google_item s">
              <img alt="Marketing" src={business} />
              <div>
                <h3 style={{ fontWeight: 500 }}>Marketing</h3>
                <p>Target audience behaviors are analyzed to deliver the right message at the right time.</p>
              </div>
            </div>
            <div className="col-md-6 manage-google_item s">
              <img alt="SaaS & Technology" src={seven} />
              <div>
                <h3 style={{ fontWeight: 500 }}>SaaS &amp; Technology</h3>
                <p>Product performance is monitored in real-time and user experience continuously improves.</p>
              </div>
            </div>
            <div className="col-md-6 manage-google_item s">
              <img alt="B2B Services" src={eight} />
              <div>
                <h3 style={{ fontWeight: 500 }}>B2B Services</h3>
                <p>All workflows from proposal to contract are accelerated with data-driven strategies.</p>
              </div>
            </div>
          </div>
        </div>

        {/* STATISTICS */}
        <div className="container">
          <h3 className="arastirma">Research Shows That Companies Using Generative AI Achieve Significant Improvements in ROI, Time Management, and Costs</h3>
          <div className="about-top_row s">
            <div className="col-md-3 s">
              <span className="yapay-p">74%</span>
              <p className="yapay-p">Companies that achieved ROI within the first year</p>
              <img className="istatistik" alt="ROI statistic" src={veri1} />
            </div>
            <div className="col-md-3 s">
              <span className="yapay-p">5.4%</span>
              <p className="yapay-p">Efficiency gained from weekly working hours</p>
              <img className="istatistik" alt="Efficiency statistic" src={veri2} />
            </div>
            <div className="col-md-3 s">
              <span className="yapay-p">15.2%</span>
              <p className="yapay-p">Average cost savings rate</p>
              <img className="istatistik" alt="Cost savings statistic" src={veri3} />
            </div>
          </div>
        </div>

        <Checkup />

        {/* FAQ */}
        <div className="onboarding container py60">
          <div className="col-md-4">
            <img alt="" src={yapayAudits} />
            <h2>Our AI<br />journey.</h2>
            <p>Take a look at how we implement AI consulting for our brands.</p>
          </div>
          <div className="col-md-8">
            <div className="hiring-tabs">
              <input type="checkbox" name="onboarding" id="tab1" />
              <input type="checkbox" name="onboarding" id="tab2" />
              <input type="checkbox" name="onboarding" id="tab3" />
              <input type="checkbox" name="onboarding" id="tab4" />

              <div className="tab" id="tab1sec">
                <label htmlFor="tab1"> </label>
                <h3><span>1</span> Discovery &amp; Assessment</h3>
                <p>- We analyze your current processes, data infrastructure, and business goals to identify the best AI integration opportunities.</p>
                <div className="plus"></div>
              </div>
              <div className="tab" id="tab2sec">
                <label htmlFor="tab2"> </label>
                <h3><span>2</span> Strategy &amp; Roadmap</h3>
                <p>- We develop a customized AI strategy and roadmap aligned with your business objectives, including tool selection and implementation priorities.</p>
                <div className="plus"></div>
              </div>
              <div className="tab" id="tab3sec">
                <label htmlFor="tab3"> </label>
                <h3><span>3</span> Implementation &amp; Integration</h3>
                <p>- We integrate AI solutions into your existing workflows, ensuring smooth adoption and minimal disruption to your operations.</p>
                <div className="plus"></div>
              </div>
              <div className="tab" id="tab4sec">
                <label htmlFor="tab4"> </label>
                <h3><span>4</span> Monitoring &amp; Optimization</h3>
                <p>- We continuously monitor AI performance, gather insights, and optimize solutions to ensure maximum ROI and business impact.</p>
                <div className="plus"></div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

export default AiConsulting
